<template>
    <div>
      <template v-for="(tag, index) in tags">
        <a-tooltip v-if="tag.length > 16" :key="tag" :title="tag">
          <a-tag :key="tag" :closable="!isShowMode" :color="color" @close="() => handleClose(tag)">
            {{ `${tag.slice(0, 16)}...` }}
          </a-tag>
        </a-tooltip>
        <a-tag v-else :key="tag" :closable="!isShowMode" :color="color" @close="() => handleClose(tag)">
          {{ tag }}
        </a-tag>
      </template>
      <span v-if="!isShowMode">
        <a-input
          v-if="inputVisible"
          ref="input"
          type="text"
          size="small"
          :style="{ width: '78px' }"
          :value="inputValue"
          @change="handleInputChange"
          @blur="handleInputConfirm"
          @keyup.enter="handleInputConfirm"
        />
        <a-tag v-else style="background: #fff; borderStyle: dashed;" @click="showInput">
          <a-icon type="plus" /> 新增
        </a-tag>
      </span>
    </div>
  </template>
  <script>
    const COMP_NAME = "FcTag";
    export default {
      name: COMP_NAME,
      props: {
          _tags: {
              type: Array,
              default() {
                  return [];
              },
          },
          _isShowMode: {
              type: Boolean,
              default() {
                return false;
              }
          },
          _color: {
              type: String,
              default() {
                  return 'blue';
              },
          }
      },
      watch: {
          _tags(o, n) {
              console.log("_tags_tags_tags_tags_tags", o,n)
              if (o !== n) {
                  this.tags = o;
              }
          },
          _isShowMode(o, n) {
              console.log("_isShowMode_isShowMode", o,n)
              if (o !== n) {
                  this.isShowMode = o;
              }
          },
      },
      data() {
        return {
          tags: this._tags,
          isShowMode: this._isShowMode,
          color: this._color,
          inputVisible: false,
          inputValue: '',
        };
      },
      methods: {
        handleClose(removedTag) {
          console.log("_isShowMode_isShowMode", this.isShowMode)
          const tags = this.tags.filter(tag => tag !== removedTag);
          console.log(tags);
          this.tags = tags;
          this.$emit('change', this.tags);
        },
    
        showInput() {
          this.inputVisible = true;
          this.$nextTick(function() {
            this.$refs.input.focus();
          });
        },
    
        handleInputChange(e) {
          this.inputValue = e.target.value;
        },
    
        handleInputConfirm() {
          const inputValue = this.inputValue;
          let tags = this.tags;
          if (inputValue && tags.indexOf(inputValue) === -1) {
            tags = [...tags, inputValue];
          }
          console.log(tags);
          Object.assign(this, {
            tags,
            inputVisible: false,
            inputValue: '',
          });
          this.$emit('change', this.tags);
        },
      },
    };
  </script>
    